/**  MODIFIED COPY OF src/common-app/state/modules/engines/transcription/reducers.ts TODO find way to reuse common code! */
import { TDOId } from '@common-modules/universal/models/Brands';
import {
  createGraphQLFailureAction,
  createGraphQLSuccessAction,
} from '@helpers/callGraphQLApi';
import { createAction } from '@reduxjs/toolkit';
import {
  CancelJobServiceResponse,
  // QueryEngineResultsServiceResponse,
} from './services';
import type { JobStatus } from 'veritone-types';

export const NOOP = 'noop';

// export const actionPrefix = 'vtn/redact/engine/voice-mask/'

/**
 * Begins the process of starting voice-mask engine job.
 * Includes polling and loading results.
 */
export const PROCESS_ENGINE_REQUEST = createAction<{
  tdoId: TDOId;
  tdoName: string;
  payload: {
    targetId: string;
  };
}>('vtn/redact/engine/voice-mask/PROCESS_ENGINE_REQUEST');
export const PROCESS_ENGINE_REQUEST_SUCCESS = createAction<{
  jobId: string;
  tdoId: TDOId;
  // jobStatus: string; // TODO: Validate this isn't used
}>('vtn/redact/engine/voice-mask/PROCESS_ENGINE_REQUEST_SUCCESS');
export const PROCESS_ENGINE_REQUEST_FAILURE = createAction(
  'vtn/redact/engine/voice-mask/PROCESS_ENGINE_REQUEST_FAILURE',
  (tdoId: TDOId, /* jobId: string,*/ errorMsg: string) => ({
    payload: {
      tdoId,
      // jobId, // TODO: Verify and fix
      errorMsg,
    },
    error: true,
  })
);

/**
 *
 * @param {{
 *   tdoId: TDOId;
 *   tdoName: string;
 * }} request
 */
export const processEngineRequestAction = ({
  tdoId,
  tdoName,
}: {
  tdoId: TDOId;
  tdoName: string;
}) => PROCESS_ENGINE_REQUEST({ tdoId, tdoName, payload: { targetId: tdoId } });

export const processEngineRequestSuccessAction = ({
  tdoId,
  jobId,
}: {
  jobId: string;
  tdoId: TDOId;
}) => PROCESS_ENGINE_REQUEST_SUCCESS({ tdoId, jobId });

export const processEngineRequestFailureAction = ({
  tdoId,
  // jobId,
  errorMsg,
}: {
  tdoId: TDOId;
  // jobId: string;
  errorMsg: string;
}) => PROCESS_ENGINE_REQUEST_FAILURE(tdoId, errorMsg);

/**
 * Create engine job actions.
 */

export const CREATE_ENGINE_JOB = createAction<{
  tdoId: TDOId;
  tdoName: string;
  payload: { targetId: string };
}>('vtn/redact/engine/voice-mask/CREATE_ENGINE_JOB');
export const CREATE_ENGINE_JOB_SUCCESS = createGraphQLSuccessAction<{
  createJob: {
    id: string;
    targetId: TDOId;
    status: string;
  };
}>('vtn/redact/engine/voice-mask/CREATE_ENGINE_JOB_SUCCESS');
export const CREATE_ENGINE_JOB_FAILURE = createGraphQLFailureAction<
  any,
  { id: TDOId; tdoName: string },
  true
>('vtn/redact/engine/voice-mask/CREATE_ENGINE_JOB_FAILURE');

/**
 *
 * @param {{ tdoId: TDOId; targetId: string; }} payload
 */
export const createEngineJobAction = ({
  tdoId,
  tdoName,
  payload,
}: {
  tdoId: TDOId;
  tdoName: string;
  payload: { targetId: string };
}) => CREATE_ENGINE_JOB({ tdoId, tdoName, payload });

/**
 * Check job status actions.
 */

export const CHECK_JOB_STATUS = createAction<{
  jobId: string;
  tdoId: TDOId;
}>('vtn/redact/engine/voice-mask/CHECK_JOB_STATUS');
export const CHECK_JOB_STATUS_SUCCESS = createGraphQLSuccessAction<{
  job: {
    id: string;
    targetId: TDOId;
    status: JobStatus;
  };
}>('vtn/redact/engine/voice-mask/CHECK_JOB_STATUS_SUCCESS');
export const CHECK_JOB_STATUS_FAILURE = createGraphQLFailureAction(
  'vtn/redact/engine/voice-mask/CHECK_JOB_STATUS_FAILURE'
);

export const checkJobStatusAction = ({
  tdoId,
  jobId,
}: {
  jobId: string;
  tdoId: TDOId;
}) => CHECK_JOB_STATUS({ tdoId, jobId });

/**
 * Check task status actions.
 */

export const CHECK_TASK_STATUS = createAction<{
  jobId: string;
  taskId: string;
  tdoId: TDOId;
}>('vtn/redact/engine/voice-mask/CHECK_TASK_STATUS');
export const CHECK_TASK_STATUS_SUCCESS = createGraphQLSuccessAction<{
  task: {
    id: string;
    jobId: string;
    targetId: TDOId;
    status: JobStatus;
  };
}>('vtn/redact/engine/voice-mask/CHECK_TASK_STATUS_SUCCESS');
export const CHECK_TASK_STATUS_FAILURE = createGraphQLFailureAction(
  'vtn/redact/engine/voice-mask/CHECK_TASK_STATUS_FAILURE'
);

export const checkTaskStatusAction = ({
  tdoId,
  jobId,
  taskId,
}: {
  jobId: string;
  tdoId: TDOId;
  taskId: string;
}) => CHECK_TASK_STATUS({ tdoId, taskId, jobId });

/**
 * Start and stop polling job status actions.
 */

export const START_POLLING_ENGINE_RESULTS = createAction<{
  jobId: string;
  taskId?: string;
  tdoId: TDOId;
}>('vtn/redact/engine/voice-mask/START_POLLING_ENGINE_RESULTS');

export const STOP_POLLING_ENGINE_RESULTS = createAction<{
  tdoId: TDOId;
  jobId: string;
}>('vtn/redact/engine/voice-mask/STOP_POLLING_ENGINE_RESULTS');

export const startPollingEngineResultsAction = ({
  tdoId,
  taskId,
  jobId,
}: {
  jobId: string;
  tdoId: TDOId;
  taskId?: string | undefined;
}) => START_POLLING_ENGINE_RESULTS({ tdoId, taskId, jobId });

export const stopPollingEngineResultsAction = ({
  tdoId,
  jobId,
}: {
  jobId: string;
  tdoId: TDOId;
}) => STOP_POLLING_ENGINE_RESULTS({ tdoId, jobId });

/**
 * Cancel a job actions.
 */

export const CANCEL_JOB = createAction<{
  jobId: string;
  tdoId: TDOId;
}>('vtn/redact/engine/voice-mask/CANCEL_JOB');
export const CANCEL_JOB_SUCCESS =
  createGraphQLSuccessAction<CancelJobServiceResponse>(
    'vtn/redact/engine/voice-mask/CANCEL_JOB_SUCCESS'
  );
export const CANCEL_JOB_FAILURE = createGraphQLFailureAction(
  'vtn/redact/engine/voice-mask/CANCEL_JOB_FAILURE'
);

export const cancelJobAction = ({
  tdoId,
  jobId,
}: {
  jobId: string;
  tdoId: TDOId;
}) => CANCEL_JOB({ tdoId, jobId });
